export default __webpack_public_path__ + "static/media/top-b-8.2ab312a0.jpg";